<template>
  <div v-if="economy.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip top v-if="showView && $permission.permissionAllow('Economies', 'view')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/economies/' +
              economy.id
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Economies.actions.detail") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.viewInfo", [$t("Economies.ObjectName")])
        }}</span>
      </v-tooltip>
      <!-- 生效 -->
      <v-tooltip top v-if="showComplete && $permission.permissionAllow('Economies', 'complete')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                $router.push('/economies/' + economy.id + '/complete');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("Economies.actions.complete") }}
          </v-btn>
        </template>
        <span>
          {{ $t("CRUD.editInfo", [$t("Economies.ObjectName")]) }}
        </span>
      </v-tooltip>
      <!-- 作废 -->
      <v-tooltip top v-if="showCancel && $permission.permissionAllow('Economies', 'cancel')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("Economies.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("Economies.actions.cancel") }}</span>
      </v-tooltip>
    </v-sheet>

    <!-- 弹窗 -->
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('Economies.ObjectName')"
      :code="economy.economy_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import Economies from "@/api/economies";

export default {
  name: "EconomiesActions",

  props: {
    detailMode: Boolean,
    economy: Object,
    showView: Boolean,
    showComplete: Boolean,
    showCancel: Boolean,
  },
  components: {
    DialogDelete,
  },
  data: () => ({
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel") return Economies.cancel(this.economy.id);
    },
    // 操作
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
  },
};
</script>